const TWITTER_BASE_URL = 'http://twitter.com/share?';
const LINKEDIN_BASE_URL = 'https://www.linkedin.com/sharing/share-offsite?url=';
const FACEBOOK_BASE_URL = ' https://www.facebook.com/sharer/sharer.php?u=';

export function shareOnTwitter(text: string, url = window.location.href) {
  const params: { [key: string]: string } = {
    url,
    text,
    original_referer: window.location.href,
  };
  let shareUrl = TWITTER_BASE_URL;
  for (const prop in params) shareUrl += `&${prop}=${encodeURIComponent(params[prop])}`;
  window.open(
    shareUrl,
    'shareBtnTWWindow',
    'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0',
  );
}

export function shareOnLinkedin(url = window.location.href) {
  const shareUrl = LINKEDIN_BASE_URL + encodeURIComponent(url);
  window.open(shareUrl, 'shareBtnLIWindow', 'width=550,height=448,resizable,scrollbars=yes,status=1');
}

export function shareOnFacebook(url = window.location.href) {
  const shareUrl = FACEBOOK_BASE_URL + encodeURIComponent(url);
  window.open(shareUrl, 'shareBtnFBWindow', 'width=555,height=655,resizable,scrollbars=yes,status=1');
}
